'use strict';

var cov_13v044lo5g = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/reportsView/reportsView.js',
        hash = 'd99eecdde701e99da11291005feb559a626813fb',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/reportsView/reportsView.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 48
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 35
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 78
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 55
                },
                end: {
                    line: 15,
                    column: 76
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 29,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 18
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 14
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 44
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 17
                    },
                    end: {
                        line: 14,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 23
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 15,
                        column: 42
                    },
                    end: {
                        line: 15,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 55
                    },
                    end: {
                        line: 15,
                        column: 76
                    }
                },
                line: 15
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 10,
                        column: 19
                    },
                    end: {
                        line: 10,
                        column: 42
                    }
                },
                type: 'default-arg',
                locations: [{
                    start: {
                        line: 10,
                        column: 26
                    },
                    end: {
                        line: 10,
                        column: 42
                    }
                }],
                line: 10
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportsViewController = function () {
    function ReportsViewController() {
        _classCallCheck(this, ReportsViewController);

        cov_13v044lo5g.f[0]++;
        cov_13v044lo5g.s[0]++;

        this.currentWeek = moment().format('W');
    }

    _createClass(ReportsViewController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_13v044lo5g.f[1]++;
            cov_13v044lo5g.s[1]++;

            this.reports.$load('user');
        }
    }, {
        key: 'generateReport',
        value: function generateReport() {
            var _this = this;

            var week = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_13v044lo5g.b[0][0]++, this.currentWeek);
            cov_13v044lo5g.f[2]++;
            cov_13v044lo5g.s[2]++;

            this.reports.$create({
                year: this.year,
                week: week
            }).$then(function () {
                cov_13v044lo5g.f[3]++;
                cov_13v044lo5g.s[3]++;

                _this.reports.$refresh().$then(function (reports) {
                    cov_13v044lo5g.f[4]++;
                    cov_13v044lo5g.s[4]++;
                    return reports.$load('user');
                });
            });
        }
    }]);

    return ReportsViewController;
}();

cov_13v044lo5g.s[5]++;


angular.module('app').component('reportsView', {
    templateUrl: 'app/components/reportsView/reportsView.html',
    controller: ReportsViewController,
    bindings: {
        reports: '<',
        year: '<'
    }
});